import { IOnInit } from "angular";

export class PartTransactionItemController implements IOnInit {
  item: any;

  $onInit(): void {}
}
